import { BoxProps, Flex, Paragraph } from '../../atoms';
import { Message } from '../message/message';

type Props = {
  leftText: string;
  linkText?: string | null;
};
export function HelpBanner({
  linkText,
  leftText,
  ...rest
}: Props & BoxProps): JSX.Element {
  return (
    <Flex
      w="100%"
      padding="space_unit.x2"
      mb="space_unit.x4"
      mt="space_unit.x2"
      justifyContent="space-between"
      backgroundColor="palette_blue.0"
      borderRadius={3}
      {...rest}
    >
      <Paragraph size="sm">{leftText}</Paragraph>
      <Message
        color="palette_blue.100"
        textDecor="underline"
        fontWeight="bold"
        fontSize="0.875rem"
        lineHeight="1.25rem"
        text={linkText}
        fallback="<a href='payflip.be'>Read more here</a>"
      />
    </Flex>
  );
}
